import * as RadixTooltip from '@radix-ui/react-tooltip'
import React from 'react'

export type TooltipThemes = 'white' | 'thatch-purple'

export const TOOLTIP_THEMES_DICT: Record<TooltipThemes, { content: string, arrow: string }> = {
  white: {
    content: 'bg-white text-gray-800',
    arrow: 'fill-white'
  },
  'thatch-purple': {
    content: 'bg-thatch-800 text-white',
    arrow: 'fill-thatch-800'
  }
}

const Tooltip = ({
  triggerChildren,
  className = '',
  theme = 'white',
  includeArrow = true,
  children,
  side = 'top'
}: {
  triggerChildren: React.ReactNode,
  className?: string,
  theme?: TooltipThemes,
  includeArrow?: boolean,
  children: React.ReactNode | string,
  side?: 'top' | 'right' | 'bottom' | 'left'
}) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>
          <button className='inline-flex items-center justify-center rounded-full bg-white outline-none' type='button'>
            {triggerChildren}
          </button>
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            className={`${TOOLTIP_THEMES_DICT[theme].content} max-w-80 z-50 p-2 text-center rounded-md text-xs data-[state=instant-open]:data-[side=top]:animate-slideDownAndFade data-[state=instant-open]:data-[side=right]:animate-slideLeftAndFade data-[state=instant-open]:data-[side=left]:animate-slideRightAndFade data-[state=instant-open]:data-[side=bottom]:animate-slideUpAndFade select-none text-[15px] leading-[1.5] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] ${className}`}
          >
            {children}
            {includeArrow && <RadixTooltip.Arrow className={TOOLTIP_THEMES_DICT[theme].arrow} />}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  )
}

export const ThatchTooltip = ({
  text,
  children,
  className,
  includeArrow = false
}: {
  text: string | React.ReactNode,
  children: React.ReactNode,
  className?: string
  includeArrow?: boolean
}) => {
  return (
    <Tooltip triggerChildren={children} theme='thatch-purple' className={className} includeArrow={includeArrow}>
      {text}
    </Tooltip>
  )
}

export default Tooltip
